import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { activityInitialState, ActivityStateProps, activityStateStore } from './activity-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class ActivityRepository extends BaseStoreRepository<ActivityStateProps> {
  constructor() {
    super(activityStateStore.pipe(select(state => state)), activityStateStore, activityInitialState);
  }
}
